import {AfterViewInit, Component, Inject, PLATFORM_ID} from "@angular/core";
import { Router} from "@angular/router";
import {roomDetails, ZIP_CODE_REG_EX} from "../../../shared/utils/utils";

import {PackageInterface, packageNameType} from "../../../shared/interfaces/package.interface";
import {environment} from "../../../../environments/environment";
import {FormControl, FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {MoreInfoInterface, RoomTypeInterface} from "../../../shared/interfaces/room-type.interface";
import {Meta, Title} from "@angular/platform-browser";
import {PackageInformationInterface} from "../../../shared/interfaces/package-information.interface";
import {PageUrlService} from "../../../core/services/pageUrl.service";
import {AnalyticsService} from "../../../core/services/analytics.service";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: "sw-package-details",
  templateUrl: "./ms-package-details.component.html",
  animations: [
    trigger('fadeIn', [
      state('hidden', style({
        opacity: 0,
        transform: 'translateY(20px)'
      })),
      state('visible', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition('hidden => visible', [
        animate('1s ease-in-out')
      ])
    ])
  ]
})
export class MsPackageDetailsComponent implements AfterViewInit{
  zipCodeForm: FormGroup = new FormGroup({
    zipCode: new FormControl<string>("", [Validators.required, Validators.pattern(ZIP_CODE_REG_EX)])
  });
  package?: PackageInformationInterface = {
    packageName: "Schoonmaak per uur",
    packageId: "ms",
    bulletPoints: [
      "Graag zelf de regie in handen houden?",
      "Alleen betalen voor de voorrijkosten en de gewerkte uren?",
      "Je weet de afmetingen van de ruimtes niet?",
      "Heb je specifieke wensen?"
    ],
    description:
      "Het schoonmaakpakket dat je zelf samenstelt. Wij leveren het schoonmaakteam, jij stuurt ze aan. Maatwerk dus!",
    // imageUrl: "https://firebasestorage.googleapis.com/v0/b/dev-sw-nl.appspot.com/o/consumerApp%2Fms.jpeg?alt=media&token=20fa9d2a-c411-403f-a79e-49dd0f23de30"
  };
  details?: MoreInfoInterface;
  id: PackageInterface["packageId"] = "ms";
  isSmallScreen = false;
  isVisible = false;

  constructor(private title: Title,
              private meta: Meta,
              private router: Router,
              private pageUrlService: PageUrlService,
              private analyticsService: AnalyticsService,
              private breakpointObserver: BreakpointObserver,
              @Inject(PLATFORM_ID) private platformId: Object,
              @Inject(DOCUMENT) private document: Document) {
    this.loadData();
  }


  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.breakpointObserver.observe([
        Breakpoints.Handset,
        '(max-width: 640px)'
      ]).subscribe(result => {
        this.isSmallScreen = result.matches;
        if (this.isSmallScreen) {
          setTimeout(() => {
            this.isVisible = true;
          }, 1000); // 1 second delay
        } else {
          this.isVisible = true;
        }
      });
    }
  }

  private loadData(): void {
    const pcg = this.router.url.split("?")[0].replace("/schoonmaakdiensten/", "") as packageNameType;
    if (pcg) {
      this.details = roomDetails.find(rd => rd?.packageId === this.id);
      this.getTags();
    }
  }


  ngAfterViewInit() {
    if(isPlatformBrowser(this.platformId) && this.package) {
      this.analyticsService.trackViewItem(this.package)
    }
  }

  onStart(form: FormGroupDirective): void {
    const zipCode = form.value?.zipCode;

    if (form.valid && isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}location?packageId=${this.id}&zipCode=${zipCode}`;
      if(this.package) {
        this.analyticsService.trackAddToCart(this.package, zipCode)
      }
      this.document.location.href = url;
    }
  }

  onOpenLink(id = this.id): void {
    if (isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}location?packageId=${id}`;
      if(this.package) {
        this.analyticsService.trackAddToCart(this.package, '', id)
      }
      this.document.location.href = url;
    }
  }

  onSelect() {
    if (isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}location?packageId=ms`;
      if(this.package) {
        this.analyticsService.trackAddToCart(this.package, '', 'ms')
      }
      this.document.location.href = url;
    }
  }

  getTags(): void {
    const pageUrl = this.pageUrlService.getPageUrl();
    const pcg = this.package?.packageName?.toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const title = `Schoonmaakwoede | ${pcg}`;
    this.title.setTitle(title);
    const tags = [
      {
        name: "title",
        content: title
      },
      {
        name: "keywords",
        content: "content=Schoonmaak op maat, Schoonmaak op maat huis, Schoonmaak op maat woning, particulier schoonmaakbedrijf, grondige schoonmaak,voorjaarsschoonmaak,voorjaar schoonmaak,lente schoonmaak,diep reinigen woonhuis,huis schoonmaken,huis schoonmaak"
      },
      {
        name: "canonical",
        content: pageUrl
      },
      {
        name: "description",
        content: "Schoonmaakwoede is specialist in de Schoonmaak op maat. Met onze getrainde schoonmaak teams maken wij je huis goed & efficiënt schoon. Bestel direct je Schoonmaak op maat!"
      },
      {
        name: "og:title",
        content: title
      },
      {
        name: "og:description",
        content: "Schoonmaakwoede is specialist in de Schoonmaak op maat. Met onze getrainde schoonmaak teams maken wij je huis goed & efficiënt schoon. Bestel direct je Schoonmaak op maat!" // Todo Desc

      },
      {
        name: "og:url",
        content: pageUrl
      },
      {
        name: "og:image",
        content: `${environment.baseUrl}/assets/logo.png` // ToDo Image we inject
      },
      {
        name: "robots",
        content: "index, follow"
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      },
      {
        charset: "UTF-8"
      },
    ];
    tags.forEach((tag: any) => this.meta.updateTag(tag));
  }
}
